import { Card, Col, Row } from 'antd';

const PackageCountWidgetLayout = ({
  children,
}: {
  children: React.ReactNode[];
}) => {
  const [chart, packageCounts] = children;
  return (
    <Card>
      <Row className="activity-widget" gutter={[16, 16]} wrap>
        <Col xs={24} md={24} lg={12}>
          {chart}
        </Col>
        <Col xs={24} md={24} lg={12} className="mt-3">
          {packageCounts}
        </Col>
      </Row>
    </Card>
  );
};

export default PackageCountWidgetLayout;
